export default "__VITE_ASSET__C0DH0mvx__"